import { Box, Card, Link, Typography, styled } from '@mui/material'
import { getCurrentYear } from 'src/admin/core/services/dateFunctions'

const FooterWrapper = styled(Card)(
  ({ theme }) => `
        border-radius: 0;
        margin-top: ${theme.spacing(4)};
`,
)

function Footer() {
  return (
    <FooterWrapper className="footer-wrapper">
      <Box
        p={4}
        display={{ xs: 'block', md: 'flex' }}
        alignItems="center"
        textAlign={{ xs: 'center', md: 'left' }}
        justifyContent="space-between"
      >
        <Box>
          <Typography variant="subtitle1">&copy; {getCurrentYear()} - Placebet Modulo Administrativo</Typography>
        </Box>
        <Typography
          sx={{
            pt: { xs: 2, md: 0 },
          }}
          variant="subtitle1"
        >
          Creado por{' '}
          <Link href="http://cgspats.com.do/" target="_blank" rel="noopener noreferrer">
            CGS PATS Dominicana
          </Link>
        </Typography>
      </Box>
    </FooterWrapper>
  )
}

export default Footer
